// @flow

import * as React from 'react';

import { Link } from 'react-router-dom';

import { useTranslator, type TranslatorProps } from '@gandi/translate';

import withDomainConfigurationProps, {
  type DomainConfigurationProps,
  type OwnProps,
} from './withProps';

type Props = DomainConfigurationProps;

function getTranslation(__: TranslatorProps['__'], templateName: string) {
  return __('%(templateName)s will be applied to these domains', {
    templateName,
  });
}

const paddingRight = { paddingRight: '1em' };

const RowContents = ({
  committed,
  configuration,
  templateChangeURL,
}: Props) => {
  const { __ } = useTranslator();

  const payload = configuration?.payload || {};
  const name = payload.template_name || __('Gandi default configuration');
  const locked = payload.locked || false;

  return (
    <>
      <span style={paddingRight}>{getTranslation(__, name)}</span>
      {!locked && !committed && (
        <Link to={templateChangeURL}>{__('Change')}</Link>
      )}
    </>
  );
};

export default (withDomainConfigurationProps(
  RowContents,
): React.ComponentType<OwnProps>);
